/* ============================================================
   MONMOUTH CARDS — Navigation & Filter JS
   monmouth-nav.js
   ============================================================
   Zero dependencies. Vanilla JS. ~10KB unminified.
   ============================================================ */

(function() {
  'use strict';

  /* Real fix (pre-launch-remaining-fixes-prompt.md, Part 2) — this file
     is loaded on every single page and its setup below binds
     document-level keydown/click listeners for the mega menu, drawer,
     and filter dropdowns. Without a guard, any re-run of this script tag
     on the same page (the same admin-preview re-render scenario already
     confirmed elsewhere in this theme) stacks a duplicate copy of every
     one of those listeners for the rest of that page session. Same
     pattern already proven in assets/monmouth-cart.js and
     assets/monmouth-mobile-fixes.js. */
  if (window.__mcNavInit) return;
  window.__mcNavInit = true;

  /* ── Utilities ── */
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ────────────────────────────────────────────
     1. MEGA MENU (Desktop)
     ──────────────────────────────────────────── */
  function initMegaMenu() {
    const menuItems = $$('.mc-nav__menu-item[data-mega]');
    let closeTimer = null;
    let currentMega = null;

    function openMega(item) {
      clearTimeout(closeTimer);
      const megaId = item.dataset.mega;
      const mega = $(`#${megaId}`);
      if (!mega) return;

      // Close any other open megas
      if (currentMega && currentMega !== mega) {
        currentMega.classList.remove('mc-mega--active');
        const prevItem = $(`[data-mega="${currentMega.id}"]`);
        if (prevItem) prevItem.classList.remove('mc-nav__menu-item--active');
      }

      mega.classList.add('mc-mega--active');
      item.classList.add('mc-nav__menu-item--active');
      currentMega = mega;
    }

    function scheduleMegaClose() {
      closeTimer = setTimeout(() => {
        if (currentMega) {
          currentMega.classList.remove('mc-mega--active');
          const prevItem = $(`[data-mega="${currentMega.id}"]`);
          if (prevItem) prevItem.classList.remove('mc-nav__menu-item--active');
          currentMega = null;
        }
      }, 180);
    }

    menuItems.forEach(item => {
      item.addEventListener('mouseenter', () => openMega(item));
      item.addEventListener('mouseleave', scheduleMegaClose);
    });

    // Keep mega open when hovering over the dropdown itself
    $$('.mc-mega').forEach(mega => {
      mega.addEventListener('mouseenter', () => clearTimeout(closeTimer));
      mega.addEventListener('mouseleave', scheduleMegaClose);
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && currentMega) {
        currentMega.classList.remove('mc-mega--active');
        const prevItem = $(`[data-mega="${currentMega.id}"]`);
        if (prevItem) prevItem.classList.remove('mc-nav__menu-item--active');
        currentMega = null;
      }
    });
  }

  /* ────────────────────────────────────────────
     2. MOBILE DRAWER
     ──────────────────────────────────────────── */
  function initDrawer() {
    const drawer = $('.mc-drawer');
    const overlay = $('.mc-drawer-overlay');
    const openBtn = $('.mc-nav__hamburger');
    const mainPanel = $('.mc-drawer__panel--main', drawer);

    if (!drawer || !openBtn || !mainPanel) return;

    let lastTrigger = null;

    /* ── Submenu (second-level sliding panel) ──
       Real fix (mobile-drawer-redesign-prompt.md) — replaces the old
       inline accordion (.mc-drawer__item-toggle / .mc-drawer__item--open)
       with the reference design's push-to-second-panel pattern. Category
       triggers are real <button>s with aria-expanded/aria-controls;
       destination links stay <a> tags — unchanged from the previous
       accordion version's semantics, just applied to the new structure. */
    function openSubmenu(key, trigger) {
      const panel = $('#mc-drawer-sub-' + key, drawer);
      if (!panel) return;
      $$('.mc-drawer__panel--sub.mc-drawer__panel--active', drawer).forEach(p => {
        p.classList.remove('mc-drawer__panel--active');
        p.setAttribute('aria-hidden', 'true');
      });
      mainPanel.classList.add('mc-drawer__panel--pushed');
      panel.classList.add('mc-drawer__panel--active');
      panel.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      lastTrigger = trigger || null;
      const back = $('.mc-drawer__back', panel);
      // preventScroll: true — a plain focus() here was scrollIntoView-ing
      // .mc-drawer__panels (its scrollable overflow region extends to
      // include the OTHER, still-offscreen translateX() panels — see the
      // contain:paint comment on that rule), which visibly dragged every
      // panel sideways in lockstep the instant this ran. The CSS fix
      // stops it at the source; this is a second, defensive layer.
      back && back.focus({ preventScroll: true });
    }

    function closeSubmenu() {
      const openPanel = $('.mc-drawer__panel--sub.mc-drawer__panel--active', drawer);
      mainPanel.classList.remove('mc-drawer__panel--pushed');
      if (openPanel) {
        openPanel.classList.remove('mc-drawer__panel--active');
        openPanel.setAttribute('aria-hidden', 'true');
      }
      $$('[data-submenu-open]', mainPanel).forEach(b => b.setAttribute('aria-expanded', 'false'));
      if (lastTrigger) { lastTrigger.focus({ preventScroll: true }); lastTrigger = null; }
    }

    function hasOpenSubmenu() {
      return !!$('.mc-drawer__panel--sub.mc-drawer__panel--active', drawer);
    }

    $$('[data-submenu-open]', mainPanel).forEach(trigger => {
      trigger.addEventListener('click', () => openSubmenu(trigger.dataset.submenuOpen, trigger));
    });
    $$('.mc-drawer__back', drawer).forEach(btn => {
      btn.addEventListener('click', closeSubmenu);
    });

    function openDrawer() {
      drawer.classList.add('mc-drawer--active');
      if (overlay) overlay.classList.add('mc-drawer-overlay--active');
      document.body.style.overflow = 'hidden';
      openBtn.setAttribute('aria-expanded', 'true');
      const closeBtn = $('.mc-drawer__close', mainPanel);
      closeBtn && closeBtn.focus({ preventScroll: true });
    }

    function closeDrawer() {
      drawer.classList.remove('mc-drawer--active');
      if (overlay) overlay.classList.remove('mc-drawer-overlay--active');
      document.body.style.overflow = '';
      openBtn.setAttribute('aria-expanded', 'false');
      openBtn.focus({ preventScroll: true });
      // Reset to the main panel so re-opening the drawer never starts
      // mid-submenu.
      closeSubmenu();
    }

    openBtn.addEventListener('click', openDrawer);
    // Every panel (main + each submenu) has its own close [X] per the
    // reference design, not just the main panel.
    $$('.mc-drawer__close', drawer).forEach(btn => {
      btn.addEventListener('click', closeDrawer);
    });
    if (overlay) overlay.addEventListener('click', closeDrawer);

    // Escape: back out of a submenu first, then close the drawer.
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape' || !drawer.classList.contains('mc-drawer--active')) return;
      if (hasOpenSubmenu()) { closeSubmenu(); return; }
      closeDrawer();
    });
  }

  /* ────────────────────────────────────────────
     3. FILTER DROPDOWNS (Desktop)
     ──────────────────────────────────────────── */
  function initFilterDropdowns() {
    const wrappers = $$('.mc-filter-wrap');

    wrappers.forEach(wrap => {
      const btn = $('.mc-filter-btn', wrap);
      const dropdown = $('.mc-filter-dropdown', wrap);
      if (!btn || !dropdown) return;

      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = dropdown.classList.contains('mc-filter-dropdown--active');

        // Close all other dropdowns
        $$('.mc-filter-dropdown--active').forEach(d => {
          d.classList.remove('mc-filter-dropdown--active');
          const parentBtn = d.closest('.mc-filter-wrap')?.querySelector('.mc-filter-btn');
          if (parentBtn) parentBtn.classList.remove('mc-filter-btn--open');
        });

        if (!isOpen) {
          dropdown.classList.add('mc-filter-dropdown--active');
          btn.classList.add('mc-filter-btn--open');
        }
      });

      // Filter option clicks
      $$('.mc-filter-dropdown__option', dropdown).forEach(opt => {
        opt.addEventListener('click', () => {
          opt.classList.toggle('mc-filter-dropdown__option--selected');
          updateFilterCount(wrap);
          updateFilterChips();
          applyFilters();
        });
      });

      // Clear button in dropdown
      const clearBtn = $('.mc-filter-dropdown__clear', dropdown);
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          $$('.mc-filter-dropdown__option--selected', dropdown).forEach(opt => {
            opt.classList.remove('mc-filter-dropdown__option--selected');
          });
          updateFilterCount(wrap);
          updateFilterChips();
          applyFilters();
        });
      }
    });

    // Close dropdowns on outside click
    document.addEventListener('click', () => {
      $$('.mc-filter-dropdown--active').forEach(d => {
        d.classList.remove('mc-filter-dropdown--active');
        const parentBtn = d.closest('.mc-filter-wrap')?.querySelector('.mc-filter-btn');
        if (parentBtn) parentBtn.classList.remove('mc-filter-btn--open');
      });
    });

    // Clear all button
    const clearAllBtn = $('.mc-filters-bar__clear');
    if (clearAllBtn) {
      clearAllBtn.addEventListener('click', () => {
        $$('.mc-filter-dropdown__option--selected').forEach(opt => {
          opt.classList.remove('mc-filter-dropdown__option--selected');
        });
        wrappers.forEach(updateFilterCount);
        updateFilterChips();
        applyFilters();
      });
    }
  }

  function updateFilterCount(wrap) {
    const btn = $('.mc-filter-btn', wrap);
    const dropdown = $('.mc-filter-dropdown', wrap);
    const count = $$('.mc-filter-dropdown__option--selected', dropdown).length;
    const countEl = $('.mc-filter-btn__count', btn);

    if (countEl) {
      countEl.textContent = count;
      countEl.style.display = count > 0 ? 'flex' : 'none';
    }

    btn.classList.toggle('mc-filter-btn--active', count > 0);
  }

  function updateFilterChips() {
    const container = $('.mc-filters-bar__chips');
    if (!container) return;

    const selected = $$('.mc-filter-dropdown__option--selected');
    const clearAll = $('.mc-filters-bar__clear');

    // Remove old chips (keep clear button)
    $$('.mc-filter-chip', container).forEach(c => c.remove());

    selected.forEach(opt => {
      const filterKey = opt.closest('.mc-filter-wrap')?.dataset.filter;
      const label = opt.dataset.value || opt.textContent.trim();
      const chip = document.createElement('span');
      chip.className = 'mc-filter-chip';
      chip.innerHTML = `
        ${label}
        <button class="mc-filter-chip__remove" data-filter="${filterKey}" data-value="${label}" aria-label="Remove filter: ${label}">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      `;
      container.insertBefore(chip, clearAll);

      chip.querySelector('.mc-filter-chip__remove').addEventListener('click', () => {
        opt.classList.remove('mc-filter-dropdown__option--selected');
        const wrap = opt.closest('.mc-filter-wrap');
        if (wrap) updateFilterCount(wrap);
        updateFilterChips();
        applyFilters();
      });
    });

    container.style.display = selected.length > 0 ? 'flex' : 'none';
    if (clearAll) clearAll.style.display = selected.length > 0 ? 'inline' : 'none';
  }

  /* ────────────────────────────────────────────
     4. SIDEBAR FILTERS
     ──────────────────────────────────────────── */
  function initSidebarFilters() {
    $$('.mc-sidebar__option').forEach(opt => {
      opt.addEventListener('click', () => {
        opt.classList.toggle('mc-sidebar__option--selected');
        applyFilters();
      });
    });

    $$('.mc-sidebar__more').forEach(btn => {
      btn.addEventListener('click', () => {
        const group = btn.closest('.mc-sidebar__group');
        if (!group) return;
        const hidden = $$('.mc-sidebar__option[hidden]', group);
        hidden.forEach(opt => opt.removeAttribute('hidden'));
        btn.style.display = 'none';
      });
    });
  }

  /* ────────────────────────────────────────────
     5. MOBILE FILTER SHEET
     ──────────────────────────────────────────── */
  function initFilterSheet() {
    const trigger = $('.mc-filter-trigger');
    const sheet = $('.mc-filter-sheet');
    const overlay = $('.mc-filter-sheet-overlay');
    const closeBtn = $('.mc-filter-sheet__close');
    const applyBtn = $('.mc-filter-sheet__apply');

    if (!trigger || !sheet) return;

    function openSheet() {
      sheet.classList.add('mc-filter-sheet--active');
      if (overlay) overlay.classList.add('mc-filter-sheet-overlay--active');
      document.body.style.overflow = 'hidden';
    }

    function closeSheet() {
      sheet.classList.remove('mc-filter-sheet--active');
      if (overlay) overlay.classList.remove('mc-filter-sheet-overlay--active');
      document.body.style.overflow = '';
    }

    trigger.addEventListener('click', openSheet);
    if (overlay) overlay.addEventListener('click', closeSheet);
    if (closeBtn) closeBtn.addEventListener('click', closeSheet);
    if (applyBtn) applyBtn.addEventListener('click', () => {
      closeSheet();
      applyFilters();
    });

    // Sheet accordion groups
    $$('.mc-filter-sheet__group-toggle', sheet).forEach(toggle => {
      toggle.addEventListener('click', () => {
        const group = toggle.closest('.mc-filter-sheet__group');
        if (group) group.classList.toggle('mc-filter-sheet__group--open');
      });
    });

    // Sheet filter options
    $$('.mc-filter-sheet__option', sheet).forEach(opt => {
      opt.addEventListener('click', () => {
        opt.classList.toggle('mc-filter-sheet__option--selected');
        updateSheetApplyCount();
      });
    });

    // Sheet clear all
    const sheetClear = $('.mc-filter-sheet__clear');
    if (sheetClear) {
      sheetClear.addEventListener('click', () => {
        $$('.mc-filter-sheet__option--selected', sheet).forEach(opt => {
          opt.classList.remove('mc-filter-sheet__option--selected');
        });
        updateSheetApplyCount();
      });
    }
  }

  function updateSheetApplyCount() {
    const applyBtn = $('.mc-filter-sheet__apply');
    const countEl = $('.mc-filter-sheet__count');
    if (!applyBtn) return;
    const count = $$('.mc-filter-sheet__option--selected').length;
    if (countEl) {
      countEl.textContent = count > 0 ? ` (${count})` : '';
    }
  }

  /* ────────────────────────────────────────────
     6. SORT
     2026-07-16: removed — this did a hard window.location.href
     navigation writing the raw dropdown value straight into the native
     sort_by param, which collided with monmouth-collection.js's
     bindSortSelect() (the current, actively-maintained handler for the
     same .mc-filters-bar__sort-select element). Harmless while both
     handlers agreed on valid native sort_by strings, but broke outright
     once the Sort By dropdown's values became tag strings like
     "sort-newest" (Filter Architecture doc "6. Universal Filters &
     Toggles") — this handler would still fire, overwrite the correct
     AJAX tag-filter navigation bindSortSelect() had just done, and land
     on a bogus ?sort_by=sort-newest URL that Shopify silently ignored.
  ──────────────────────────────────────────── */

  /* ────────────────────────────────────────────
     7. APPLY FILTERS → URL
     ──────────────────────────────────────────── */
  function applyFilters() {
    // Collect all selected filters
    const filters = {};

    // From dropdowns
    $$('.mc-filter-wrap').forEach(wrap => {
      const key = wrap.dataset.filter;
      const values = $$('.mc-filter-dropdown__option--selected', wrap).map(
        opt => opt.dataset.value || opt.textContent.trim()
      );
      if (values.length > 0) filters[key] = values;
    });

    // From sidebar
    $$('.mc-sidebar__group').forEach(group => {
      const key = group.dataset.filter;
      const values = $$('.mc-sidebar__option--selected', group).map(
        opt => opt.dataset.value || opt.textContent.trim()
      );
      if (values.length > 0) {
        filters[key] = (filters[key] || []).concat(values);
      }
    });

    // Build URL params
    const url = new URL(window.location.href);

    // Clear existing filter params
    ['sport', 'format', 'brand', 'year', 'line', 'price', 'availability'].forEach(key => {
      url.searchParams.delete(key);
    });

    // Set new params
    Object.entries(filters).forEach(([key, values]) => {
      values.forEach(v => url.searchParams.append(key, v));
    });

    // For a Shopify store using tag-based filtering:
    // This would typically use Shopify's collection filtering API
    // or navigate to a filtered collection URL.
    // The exact implementation depends on your Shopify theme setup.

    // Option A: Full page navigation (simple)
    // window.location.href = url.toString();

    // Option B: AJAX update (better UX — requires collection template support)
    // fetchFilteredProducts(url);

    // For now, dispatch a custom event so the theme can handle it
    window.dispatchEvent(new CustomEvent('mc:filters-changed', {
      detail: { filters, url: url.toString() }
    }));
  }

  /* ────────────────────────────────────────────
     8. MOBILE SEARCH OVERLAY
     ──────────────────────────────────────────── */
  function initMobileSearch() {
    const toggleBtn  = $('#mc-search-toggle');
    const closeBtn   = $('#mc-mobile-search-close');
    const overlay    = $('#mc-mobile-search');
    const input      = $('#mc-mobile-search-input');

    if (!toggleBtn || !overlay) return;

    function openSearch() {
      overlay.classList.add('mc-nav__mobile-search--active');
      overlay.setAttribute('aria-hidden', 'false');
      toggleBtn.setAttribute('aria-expanded', 'true');
      // slight delay so the transition is visible before focus
      setTimeout(() => input && input.focus(), 80);
    }

    function closeSearch() {
      overlay.classList.remove('mc-nav__mobile-search--active');
      overlay.setAttribute('aria-hidden', 'true');
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.focus();
    }

    toggleBtn.addEventListener('click', openSearch);
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && overlay.classList.contains('mc-nav__mobile-search--active')) {
        closeSearch();
      }
    });
  }

  /* ────────────────────────────────────────────
     INIT
     ──────────────────────────────────────────── */
  function init() {
    /* Real fix (mobile-round2-visual-fixes-prompt.md Fix 1) — this used to
       call initAnnouncement(), which cloned .mc-announce__track's innerHTML
       on top of the seamless-loop duplication sections/monmouth-announcement.
       liquid already does itself (real content + an aria-hidden duplicate).
       Stacking both left 4 copies in the track instead of the 2 the
       -50% marquee keyframe is built for, so the animation only ever
       scrolled through half of the doubled-up content before snapping —
       the garbled, overlapping "text on text" effect. The Liquid-side
       duplication is already correct and already accessible; removed the
       redundant JS duplication entirely rather than reconciling the two. */
    initMegaMenu();
    initDrawer();
    initMobileSearch();
    initFilterDropdowns();
    initSidebarFilters();
    initFilterSheet();

    // Initialize filter chip display
    updateFilterChips();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
